export enum disputesActionTypes {
    SET_DISPUTES_LOADING = 'SET_DISPUTES_LOADING',
    FETCH_DISPUTES_SUCCESS = 'FETCH_DISPUTES_SUCCESS',
    SET_DISPUTE_DETAILS_LOADING = 'SET_DISPUTE_DETAILS_LOADING',
    FETCH_DISPUTES_DETAILS = 'FETCH_DISPUTES_DETAILS',
    SET_DISPUTE_DETAILS_TO_DEFAULT = 'SET_DISPUTE_DETAILS_TO_DEFAULT',
    FETCH_DISPUTES_FAIL = 'FETCH_DISPUTES_FAIL',
    SET_DATETIME = 'SET_DATETIME',
    SET_DATETIME_ERROR = 'SET_DATETIME_ERROR',
    SET_TIMEZONE = 'SET_TIMEZONE',
    SET_TIMEZONE_ERROR = 'SET_TIMEZONE_ERROR',
    SET_QUERY_STRING = 'SET_QUERY_STRING',
    SET_QUERY_STRING_ERROR = 'SET_QUERY_STRING_ERROR',
    SET_PAGINATION = 'SET_QUERY_PAGINATION',
    SET_PAGINATION_ERROR = 'SET_QUERY_PAGINATION_ERROR',
    SET_SORTING = 'SET_SORTING',
    SET_DISPUTES_EXPORT_LOADING = 'SET_DISPUTES_EXPORT_LOADING',
    FETCH_DISPUTES_EXPORT_SUCCESS = 'FETCH_DISPUTES_EXPORT_SUCCESS',
    FETCH_DISPUTES_EXPORT_FAIL = 'FETCH_DISPUTES_EXPORT_FAIL',
    SET_DEFAULT_VALUES = 'SET_DEFAULT_VALUES',
    FETCH_DISPUTES_MANAGEMENT_SYSTEM = 'FETCH_DISPUTES_MANAGEMENT_SYSTEM',
    FETCH_KOUNT_STATUS_CODES = 'FETCH_KOUNT_STATUS_CODES',
    FETCH_DISPUTES_CARD_TYPES = 'FETCH_DISPUTES_CARD_TYPES',
    SET_DISPUTES_PROVIDER_NAME = 'SET_DISPUTES_PROVIDER_NAME',
    SET_DISPUTES_CARD_TYPE = 'SET_DISPUTES_CARD_TYPE',
    SET_DISPUTE_TYPES = 'SET_DISPUTE_TYPES',
    SET_IS_WEBHOOK = 'SET_IS_WEBHOOK',
    SET_IS_FILE_IMPORTED = 'SET_IS_FILE_IMPORTED',
    SET_IS_MANUAL_INSERTED = 'SET_IS_MANUAL_INSERTED',
    CLEAR_FILTER = 'CLEAR_FILTER',
    SET_DISPUTE_MATCH_LOADING = 'SET_DISPUTE_MATCH_LOADING',
    ALERT_KOUNT_LOADING = 'ALERT_KOUNT_LOADING',
    FETCH_DISPUTE_DETAILS_LISTS = 'FETCH_DISPUTE_DETAILS_LISTS',
    SET_ARCHIVATING_DISPUTE_LOADING = 'SET_ARCHIVATING_DISPUTE_LOADING',
    FETCH_DISPUTE_QUEUES = 'FETCH_DISPUTE_QUEUES',
    SET_DISPUTE_QUEUE_LOADING = 'SET_DISPUTE_QUEUE_LOADING',
    SET_IS_PROVIDER_NAME = 'SET_IS_PROVIDER_NAME',
    SET_DISPUTES_QUEUE_DATA_TO_DEFAULT = 'SET_DISPUTES_QUEUE_DATA_TO_DEFAULT',
    SET_DISPUTES_QUEUE_ITEMS_LIST_DATA_TO_DEFAULT = 'SET_DISPUTES_QUEUE_ITEMS_LIST_DATA_TO_DEFAULT',
    FETCH_REPORT_PROVIDERS_LIST = 'FETCH_REPORT_PROVIDERS_LIST',
    SET_REPORT_PROVIDERS_LIST_LOADING = 'SET_REPORT_PROVIDERS_LIST_LOADING',
}
